import { render, staticRenderFns } from "./notlar.vue?vue&type=template&id=3a82be66"
import script from "./notlar.vue?vue&type=script&lang=js"
export * from "./notlar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports